export class LeaveSelectionFilters {
    EmpresaID: number;
    Trabajador = '';
    LeaveType = '';
    EmpresaSelec = true;
    IsActiveLeave = true;
    MedicoId: number;
    Consentimiento = '';
    Weekday: number;
    WeekdayCount: number;
    DiagnosisFrom = '';
    DiagnosisTo = '';
    IsNoDiagnosis = false;
    NoDiagnosisReason = '';
    PsychosocialRisks = '';
    CommonDateFrom = ''; // Passed as an UTC String
    CommonDateTo = ''; // Passed as an UTC String
    NewLeaveDateFrom = ''; // Passed as an UTC String
    NewLeaveDateTo = ''; // Passed as an UTC String
    DischargeDateFrom = ''; // Passed as an UTC String
    DischargeDateTo = ''; // Passed as an UTC String
    CommunicationDateFrom = ''; // Passed as an UTC String
    CommunicationDateTo = ''; // Passed as an UTC String
    LeaveDaysFrom: number;
    LeaveDaysTo: number;
    LeaveEndOfPeriodDaysFrom: number;
    LeaveEndOfPeriodDaysTo: number;
    LeaveInPeriodDaysFrom: number;
    LeaveInPeriodDaysTo: number;
    LaborDaysFrom: number;
    LaborDaysTo: number;
    LaborEndOfPeriodDaysFrom: number;
    LaborEndOfPeriodDaysTo: number;
    LaborInPeriodDaysFrom: number;
    LaborInPeriodDaysTo: number;
    LeaveCommunicationGapDaysFrom: number;
    LeaveCommunicationGapDaysTo: number;
    Coordinador = '';
    Gestor = '';
    Ordern = '0';
    AttributeList = [];
    BajasOrdern = '';
    MarcaList = [];
    PageIndex = 0;
    PageSize = 0;
    diferenciarVisitaContacto='';
    Idioma=''
    ColumnsList:any;
    Nivel1:string;
    Nivel2:string;
    Nivel3:string;
    Nivel4:string;
    Nivel5:string;
    Poblacion:string;
    Provincia:string;
}

